import * as React from "react";

export const MailIcon = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_9842_1852)">
      <path
        d="M3.2002 8.80039C3.2002 7.47539 4.2752 6.40039 5.6002 6.40039H26.4002C27.7252 6.40039 28.8002 7.47539 28.8002 8.80039V12.8704C27.5802 12.3104 26.2302 12.0004 24.8002 12.0004C20.4152 12.0004 16.7152 14.9404 15.5652 18.9604C15.2102 18.8954 14.8602 18.7504 14.5602 18.5204L4.1602 10.7204C3.5552 10.2654 3.2002 9.55539 3.2002 8.80039ZM15.2002 21.6004C15.2002 23.0304 15.5102 24.3804 16.0702 25.6004H6.4002C4.6352 25.6004 3.2002 24.1654 3.2002 22.4004V13.0004L13.1202 20.4404C13.7502 20.9104 14.4652 21.2104 15.2052 21.3354C15.2052 21.4254 15.2002 21.5104 15.2002 21.6004ZM17.6002 21.6004C17.6002 17.6254 20.8252 14.4004 24.8002 14.4004C28.7752 14.4004 32.0002 17.6254 32.0002 21.6004C32.0002 25.5754 28.7752 28.8004 24.8002 28.8004C20.8252 28.8004 17.6002 25.5754 17.6002 21.6004ZM27.6702 18.5554C27.3152 18.2954 26.8102 18.3754 26.5502 18.7304L23.9002 22.3754L22.5602 21.0354C22.2502 20.7254 21.7402 20.7254 21.4302 21.0354C21.1202 21.3454 21.1202 21.8554 21.4302 22.1654L23.4302 24.1654C23.5952 24.3304 23.8252 24.4154 24.0602 24.3954C24.2952 24.3754 24.5052 24.2554 24.6452 24.0704L27.8452 19.6704C28.1052 19.3154 28.0252 18.8104 27.6702 18.5554Z"
        fill="#CCCFD3"
      />
    </g>
    <defs>
      <clipPath id="clip0_9842_1852">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
